export default __webpack_public_path__ + "static/media/twitter.27a4b693.svg";